import { PrescriptionItemsPropsT } from "@interfaces/prescriptions";
import React from "react";

import clsx from "clsx";
import style from "@scss/pages/prescription/prescriptions.module.scss";
import { PrescriptionItem } from "./prescription-item";

export const PrescriptionItems: React.FC<PrescriptionItemsPropsT> = ({
  rows,
  singleMode = false,
}) => {

  return (
    <div className={clsx(style.prescriptions)}>
      {rows.map((prescription) => (
        <PrescriptionItem
          key={prescription.id}
          prescription={prescription}
          singleMode={singleMode}
        />
      ))}
    </div>
  );
};
